<template>
  <div class="wc-layout wc-layout--mobile-account-subpage">
    <WCMobileSubpageHeader :title="$route.meta.title ? $route.meta.title : $route.name" />
    <div class="wc-layout__body container-fluid" role="main">
      <div class="row">
        <router-view />
      </div>
    </div>
    <WCEmployeeAssociationBanner v-if="isEmployee && isCustomer" />
    <WCBottomNavigation v-else-if="!isEmployee" />
  </div>
</template>

<script>
import WCMobileSubpageHeader from '@/components/WCMobileSubpageHeader/WCMobileSubpageHeader.vue';
import WCBottomNavigation from '@/components/WCBottomNavigation/WCBottomNavigation.vue';
import EmployeeMixin from '@/modules/employee/mixins/EmployeeMixin';
import WCEmployeeAssociationBanner from '@/modules/employee/components/WCEmployeeAssociationBanner/WCEmployeeAssociationBanner.vue';

export default {
  name: 'MobileSubpageHeader',
  components: { WCMobileSubpageHeader, WCBottomNavigation, WCEmployeeAssociationBanner },
  mixins: [EmployeeMixin],
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/tools';
@import '~@/assets/styles/settings';

.wc-layout--mobile-account-subpage {
  .wc-layout__body {
    // Add the device's bottom safe-area inset on top of the nav's own height, or trailing
    // content/buttons can end up cut off behind the fixed bottom nav on notched devices.
    padding-bottom: calc(#{$mobile-body-padding-bottom} + env(safe-area-inset-bottom, 0px));
  }
}
</style>
